import { FichaComplementarZikaMicrocefaliaResultadoExameEnum } from 'graphql/types.generated'
import { range, required, validate } from 'util/validation'

import { ResultadoExameMarcadoresBioquimicosDecimalField } from './adicionar/exames-especificos/ResultadoExameMarcadoresBioquimicosDecimalField'
import { ResultadoExameMarcadoresBioquimicosNumberField } from './adicionar/exames-especificos/ResultadoExameMarcadoresBioquimicosNumberField'
import { ResultadoExamePrenatalField } from './adicionar/exames-especificos/ResultadoExamePrenatalField'
import { ResultadoExamePuericulturaField } from './adicionar/exames-especificos/ResultadoExamePuericulturaField'
import { validateResultadoExamePrenatal, validateResultadoExamePuericultura } from './adicionar/validator'
import {
  CodigosExamesEspecificos,
  ExameQueryModel,
  FactoryResultadoExameEspecificoFieldProps,
  FactoryResultadoExameEspecificoModel,
  FactoryResultadoExameEspecificoProperties,
  FactoryResultadoExameEspecificoViewProps,
} from './model'
import { ResultadoExameMarcadoresBioquimicosView } from './visualizar/exames-especificos/ResultadoExameMarcadoresBioquimicosView'
import { ResultadoExamePrenatalView } from './visualizar/exames-especificos/ResultadoExamePrenatalView'
import { ResultadoExamePuericulturaView } from './visualizar/exames-especificos/ResultadoExamePuericulturaView'

const RESULTADOS_EXAMES_PREFIX = 'id'

const resultadosExamesEspecificosFactory: Record<CodigosExamesEspecificos, FactoryResultadoExameEspecificoModel> = {
  '0202010503': {
    validator: ({ value }) => validate(value, [required, range(0, 100)]),
    components: {
      ResultadoField: ResultadoExameMarcadoresBioquimicosDecimalField,
      ResultadoView: ResultadoExameMarcadoresBioquimicosView,
    },
    properties: {
      maxLength: 5,
      precision: 2,
      unit: '%',
    },
  },
  '0202010295': {
    validator: ({ value }) => validate(value, [required, range(1, 10000)]),
    components: {
      ResultadoField: ResultadoExameMarcadoresBioquimicosNumberField,
      ResultadoView: ResultadoExameMarcadoresBioquimicosView,
    },
    properties: {
      maxLength: 5,
      unit: 'mg/dL',
    },
  },
  ABEX002: {
    validator: ({ value }) => validate(value, [required, range(1, 10000)]),
    components: {
      ResultadoField: ResultadoExameMarcadoresBioquimicosNumberField,
      ResultadoView: ResultadoExameMarcadoresBioquimicosView,
    },
    properties: {
      maxLength: 5,
      unit: 'mg/dL',
    },
  },
  '0202010279': {
    validator: ({ value }) => validate(value, [required, range(1, 10000)]),
    components: {
      ResultadoField: ResultadoExameMarcadoresBioquimicosNumberField,
      ResultadoView: ResultadoExameMarcadoresBioquimicosView,
    },
    properties: {
      maxLength: 5,
      unit: 'mg/dL',
    },
  },
  ABEX007: {
    validator: ({ value }) => validate(value, [required, range(1, 10000)]),
    components: {
      ResultadoField: ResultadoExameMarcadoresBioquimicosNumberField,
      ResultadoView: ResultadoExameMarcadoresBioquimicosView,
    },
    properties: {
      maxLength: 5,
      unit: 'mg/dL',
    },
  },
  '0202010287': {
    validator: ({ value }) => validate(value, [required, range(1, 10000)]),
    components: {
      ResultadoField: ResultadoExameMarcadoresBioquimicosNumberField,
      ResultadoView: ResultadoExameMarcadoresBioquimicosView,
    },
    properties: {
      maxLength: 5,
      unit: 'mg/dL',
    },
  },
  ABEX009: {
    validator: ({ value }) => validate(value, [required, range(1, 10000)]),
    components: {
      ResultadoField: ResultadoExameMarcadoresBioquimicosNumberField,
      ResultadoView: ResultadoExameMarcadoresBioquimicosView,
    },
    properties: {
      maxLength: 5,
      unit: 'mg/dL',
    },
  },
  '0202010678': {
    validator: ({ value }) => validate(value, [required, range(1, 10000)]),
    components: {
      ResultadoField: ResultadoExameMarcadoresBioquimicosNumberField,
      ResultadoView: ResultadoExameMarcadoresBioquimicosView,
    },
    properties: {
      maxLength: 5,

      unit: 'mg/dL',
    },
  },
  '0202010317': {
    validator: ({ value }) => validate(value, [required, range(0.1, 500)]),
    components: {
      ResultadoField: ResultadoExameMarcadoresBioquimicosDecimalField,
      ResultadoView: ResultadoExameMarcadoresBioquimicosView,
    },
    properties: {
      maxLength: 5,
      precision: 1,
      unit: 'mg/dL',
    },
  },
  ABEX003: {
    validator: ({ value }) => validate(value, [required, range(0.1, 500)]),
    components: {
      ResultadoField: ResultadoExameMarcadoresBioquimicosDecimalField,
      ResultadoView: ResultadoExameMarcadoresBioquimicosView,
    },
    properties: {
      maxLength: 5,
      precision: 1,
      unit: 'mg/dL',
    },
  },
  '0202050025': {
    validator: ({ value }) => validate(value, [required, range(0.001, 1000)]),
    components: {
      ResultadoField: ResultadoExameMarcadoresBioquimicosDecimalField,
      ResultadoView: ResultadoExameMarcadoresBioquimicosView,
    },
    properties: {
      maxLength: 7,
      precision: 3,
      unit: 'mL/min/1,73 m²',
    },
  },
  '0205020143': {
    validator: validateResultadoExamePrenatal,
    components: {
      ResultadoField: ResultadoExamePrenatalField,
      ResultadoView: ResultadoExamePrenatalView,
    },
  },
  '0205020151': {
    validator: validateResultadoExamePrenatal,
    components: {
      ResultadoField: ResultadoExamePrenatalField,
      ResultadoView: ResultadoExamePrenatalView,
    },
  },
  '0205010059': {
    validator: validateResultadoExamePrenatal,
    components: {
      ResultadoField: ResultadoExamePrenatalField,
      ResultadoView: ResultadoExamePrenatalView,
    },
  },
  '0211070149': {
    validator: validateResultadoExamePuericultura,
    components: {
      ResultadoField: ResultadoExamePuericulturaField,
      ResultadoView: ResultadoExamePuericulturaView,
    },
    properties: {
      options: [
        FichaComplementarZikaMicrocefaliaResultadoExameEnum.ORELHINHA_FALHOU,
        FichaComplementarZikaMicrocefaliaResultadoExameEnum.ORELHINHA_PASSOU,
      ],
    },
  },
  '0211070270': {
    validator: validateResultadoExamePuericultura,
    components: {
      ResultadoField: ResultadoExamePuericulturaField,
      ResultadoView: ResultadoExamePuericulturaView,
    },
    properties: {
      options: [
        FichaComplementarZikaMicrocefaliaResultadoExameEnum.ORELHINHA_FALHOU,
        FichaComplementarZikaMicrocefaliaResultadoExameEnum.ORELHINHA_PASSOU,
      ],
    },
  },
  '0205020178': {
    validator: validateResultadoExamePuericultura,
    components: {
      ResultadoField: ResultadoExamePuericulturaField,
      ResultadoView: ResultadoExamePuericulturaView,
    },
    properties: {
      options: [
        FichaComplementarZikaMicrocefaliaResultadoExameEnum.TRANSFONTANELA_NORMAL,
        FichaComplementarZikaMicrocefaliaResultadoExameEnum.TRANSFONTANELA_SUGESTIVO_INFECCAO_CONGENITA,
        FichaComplementarZikaMicrocefaliaResultadoExameEnum.TRANSFONTANELA_OUTRAS_ALTERACOES,
        FichaComplementarZikaMicrocefaliaResultadoExameEnum.TRANSFONTANELA_INDETERMINADO,
      ],
    },
  },
  '0206010079': {
    validator: validateResultadoExamePuericultura,
    components: {
      ResultadoField: ResultadoExamePuericulturaField,
      ResultadoView: ResultadoExamePuericulturaView,
    },
    properties: {
      options: [
        FichaComplementarZikaMicrocefaliaResultadoExameEnum.TOMOGRAFIA_NORMAL,
        FichaComplementarZikaMicrocefaliaResultadoExameEnum.TOMOGRAFIA_SUGESTIVO_INFECCAO_CONGENITA,
        FichaComplementarZikaMicrocefaliaResultadoExameEnum.TOMOGRAFIA_OUTRAS_ALTERACOES,
        FichaComplementarZikaMicrocefaliaResultadoExameEnum.TOMOGRAFIA_INDETERMINADO,
      ],
    },
  },
  '0207010064': {
    validator: validateResultadoExamePuericultura,
    components: {
      ResultadoField: ResultadoExamePuericulturaField,
      ResultadoView: ResultadoExamePuericulturaView,
    },
    properties: {
      options: [
        FichaComplementarZikaMicrocefaliaResultadoExameEnum.RESSONANCIA_NORMAL,
        FichaComplementarZikaMicrocefaliaResultadoExameEnum.RESSONANCIA_SUGESTIVO_INFECCAO_CONGENITA,
        FichaComplementarZikaMicrocefaliaResultadoExameEnum.RESSONANCIA_OUTRAS_ALTERACOES,
        FichaComplementarZikaMicrocefaliaResultadoExameEnum.RESSONANCIA_INDETERMINADO,
      ],
    },
  },
  '0211060100': {
    validator: validateResultadoExamePuericultura,
    components: {
      ResultadoField: ResultadoExamePuericulturaField,
      ResultadoView: ResultadoExamePuericulturaView,
    },
    properties: {
      options: [
        FichaComplementarZikaMicrocefaliaResultadoExameEnum.FUNDO_OLHO_NORMAL,
        FichaComplementarZikaMicrocefaliaResultadoExameEnum.FUNDO_OLHO_ALTERADO,
      ],
    },
  },
  ABEX022: {
    validator: validateResultadoExamePuericultura,
    components: {
      ResultadoField: ResultadoExamePuericulturaField,
      ResultadoView: ResultadoExamePuericulturaView,
    },
    properties: {
      options: [
        FichaComplementarZikaMicrocefaliaResultadoExameEnum.PRESENTE_BILATERAL,
        FichaComplementarZikaMicrocefaliaResultadoExameEnum.DUVIDOSO_OU_AUSENTE,
      ],
    },
  },
}

const examesEspecificosKeys = Object.keys(resultadosExamesEspecificosFactory)

const mapResultadosPuericulturaEnumLabel: Record<FichaComplementarZikaMicrocefaliaResultadoExameEnum, string> = {
  ORELHINHA_FALHOU: 'Falhou',
  ORELHINHA_PASSOU: 'Passou',
  TRANSFONTANELA_NORMAL: 'Normal',
  TRANSFONTANELA_SUGESTIVO_INFECCAO_CONGENITA: 'Sugestivo de infecção congênita',
  TRANSFONTANELA_OUTRAS_ALTERACOES: 'Outras alterações',
  TRANSFONTANELA_INDETERMINADO: 'Indeterminado',
  TOMOGRAFIA_NORMAL: 'Normal',
  TOMOGRAFIA_SUGESTIVO_INFECCAO_CONGENITA: 'Sugestivo de infecção congênita',
  TOMOGRAFIA_OUTRAS_ALTERACOES: 'Outras alterações',
  TOMOGRAFIA_INDETERMINADO: 'Indeterminado',
  RESSONANCIA_NORMAL: 'Normal',
  RESSONANCIA_SUGESTIVO_INFECCAO_CONGENITA: 'Sugestivo de infecção congênita',
  RESSONANCIA_OUTRAS_ALTERACOES: 'Outras alterações',
  RESSONANCIA_INDETERMINADO: 'Indeterminado',
  FUNDO_OLHO_NORMAL: 'Normal',
  FUNDO_OLHO_ALTERADO: 'Alterado',
  DUVIDOSO_OU_AUSENTE: 'Duvidoso ou ausente',
  PRESENTE_BILATERAL: 'Presente bilateral',
}

export const isExameEspecifico = (exame: ExameQueryModel): boolean =>
  examesEspecificosKeys.includes(getExameCodigo(exame))

export const getExameCodigo = (exame: ExameQueryModel): string =>
  exame.procedimentoReferencia ? exame.procedimentoReferencia.codigo : exame.codigo

export const getResultadoExameEspecificoProperties = (
  exame: ExameQueryModel
): FactoryResultadoExameEspecificoProperties => {
  return resultadosExamesEspecificosFactory?.[getExameCodigo(exame)]?.properties || {}
}

export const getResultadoExameEspecificoField = (
  exame: ExameQueryModel
): React.ComponentType<FactoryResultadoExameEspecificoFieldProps> => {
  return resultadosExamesEspecificosFactory?.[getExameCodigo(exame)]?.components?.ResultadoField
}

export const getResultadoExameEspecificoView = (
  exame: ExameQueryModel
): React.ComponentType<FactoryResultadoExameEspecificoViewProps> => {
  return resultadosExamesEspecificosFactory?.[getExameCodigo(exame)]?.components?.ResultadoView
}

export const getResultadoExameEspecificoValidator = (
  exame: ExameQueryModel
): FactoryResultadoExameEspecificoModel['validator'] => {
  return resultadosExamesEspecificosFactory?.[getExameCodigo(exame)]?.validator
}

export const getResultadoExameEspecificoPuericulturaLabel = (
  value: FichaComplementarZikaMicrocefaliaResultadoExameEnum
): string => {
  return mapResultadosPuericulturaEnumLabel[value]
}

export const addPrefix = (value: ID): string => RESULTADOS_EXAMES_PREFIX + value
export const removePrefix = (value: string): ID => value.replace(RESULTADOS_EXAMES_PREFIX, '')
